export const PANINDA_TAGS = ['Kotlin', 'Java', 'PostgreSQL'];

export const ALGOSENSEI_TAGS = ['React', 'Java', 'PostgreSQL', 'Docker', 'Python'];
